// src/modules/user/pages/activities/surveyAnswerForm.jsx
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import _ from 'lodash';
import { Typography } from '@material-ui/core';
import { FORM_RULES } from 'helpers/validations';
import { getUserPoints } from 'modules/user/pages/homepage/homepageActions';
import ButtonPrimary from 'common/components/buttons/ButtonPrimary';
import {
  BoxSelect,
  InputLabelOutlined,
  MultipleChoices,
  SelectLabel,
  SelectMultiple,
  InputEasyImageWithProcessing,
  InputGenericFile,
} from 'common/components/fields/fields';
import {
  COMPANY_COLORS,
  COMPANY_SIGNED_IN_BACKGROUND_COLOR,
} from 'config/consts';
import {
  getLottieById,
  setFeedbackModal,
  submitSurvey,
} from './activitiesActions';
import { cpfMask, dateMask } from 'helpers/masks';

let SurveysForm = function (props) {
  const [step, setStep] = useState(0);

  const questions = useMemo(() => {
    return props.questions.map((item, index) => {
      const typeId = parseInt(item.type_id, 10);
      const isRequired = item.required !== false;
      const requiredValidation = isRequired ? [FORM_RULES.required] : [];

      if (typeId === 1) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Field
                component={SelectLabel}
                type="text"
                label={`Selecione apenas uma`}
                name={`contactSurveyAnswer-${item.id}-1`}
                step={step}
                validate={requiredValidation}
                options={item.options.map(opt => ({
                  value: opt.id,
                  label: opt.label,
                }))}
                isLong
                longText={item.question}
              />
            </div>
          </div>
        );
      } else if (typeId === 2) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Field
                component={SelectMultiple}
                name={`contactSurveyAnswer-${item.id}`}
                step={step}
                label={`Selecione uma ou mais`}
                validate={requiredValidation}
                options={item.options.map(opt => ({
                  value: opt.id,
                  label: opt.label,
                }))}
                isLong
                longText={item.question}
              />
            </div>
          </div>
        );
      } else if (typeId === 3) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Field
                component={InputLabelOutlined}
                type="text"
                label={`Responda aqui`}
                step={step}
                multiline={true}
                limitChar={600}
                name={`contactSurveyAnswer-${item.id}`}
                validate={[...requiredValidation, FORM_RULES.max(600)]}
                isLong
                longText={item.question}
                {...(item.question.toLowerCase().includes('cpf')
                  ? cpfMask
                  : item.question.toLowerCase().includes('data')
                  ? dateMask
                  : {})}
              />
            </div>
          </div>
        );
      } else if (typeId === 4) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Field
                component={MultipleChoices}
                type="text"
                label={`Selecione apenas uma`}
                step={step}
                name={`contactSurveyAnswer-${item.id}-1`}
                validate={requiredValidation}
                options={item.options.map(opt => ({
                  value: opt.id,
                  label: opt.label,
                }))}
                otherOption={item.otherOption}
                isLong
                longText={item.question}
              />
            </div>
          </div>
        );
      } else if (typeId === 5) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Field
                component={BoxSelect}
                type="text"
                label={`Selecione uma ou mais`}
                step={step}
                name={`contactSurveyAnswer-${item.id}`}
                validate={requiredValidation}
                otherOption={item.otherOption}
                options={item.options.map(opt => ({
                  value: opt.id,
                  label: opt.label,
                }))}
                isLong
                longText={item.question}
              />
            </div>
          </div>
        );
      } else if (typeId === 6) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Typography
                variant="body1"
                style={{ textAlign: 'center', marginBottom: 20 }}
              >
                {item.question}
              </Typography>
              <Field
                component={InputEasyImageWithProcessing}
                name={`contactSurveyAnswer-${item.id}`}
                label="Tamanho máximo: 10MB"
                aspectLabel={'livre'}
                margin="normal"
                cols="12"
                step={step}
                validate={requiredValidation}
                acceptVideo
                maxSize={10000000}
              />
            </div>
          </div>
        );
      } else if (typeId === 7) {
        return (
          <div key={index} className="row justify-content-center mb-2">
            <div className="col-12">
              <Typography
                variant="body1"
                style={{ textAlign: 'center', marginBottom: 20 }}
              >
                {item.question}
              </Typography>
              <Field
                component={InputGenericFile}
                name={`contactSurveyAnswer-${item.id}`}
                label="Tamanho máximo: 10MB"
                //validate={[FORM_RULES.required]}
              />
            </div>
          </div>
        );
      }

      return null;
    });
  }, [props.questions, step]);

  function onSubmit(values) {
    if (step < questions.length - 1) {
      setStep(s => s + 1);
      return;
    }

    const { auth } = props;
    const newValues = { ...values };
    // adicionar estabelecimento
    newValues.author =
      props.activities.detail.type_id === 7 ? 'contact' : 'user';
    newValues.user = auth.user.id;
    /* newValues.contact = auth.user.id; */
    newValues.action = props.activities.detail.id;
    newValues.establishment = auth.user.establishment_participant.id;
    newValues.research = props.activities.detail.researches[0].id;

    // montar array de respostas
    let arr = [];
    for (let prop in newValues) {
      if (prop.indexOf('contactSurveyAnswer') > -1) {
        if (
          (!_.isArray(newValues[prop]) && prop.split('-').length < 3) ||
          _.isString(newValues[prop])
        ) {
          arr.push({
            answer: newValues[prop],
            question: prop.split('-')[1],
          });
        } else if (prop.split('-').length > 2) {
          arr.push({
            options: [newValues[prop]],
            question: prop.split('-')[1],
          });
        } else {
          arr.push({
            options: newValues[prop],
            question: prop.split('-')[1],
          });
        }
        delete newValues[`${prop}`];
      }
    }
    newValues.answers = arr;

    // lógica de pontuação para type 6 e type 7
    if (
      props.activities.detail.type_id === 6 ||
      props.activities.detail.type_id === 7
    ) {
      const questions = props.activities.detail.researches[0].questions;
      let correctAnswers = 0;
      for (let answer of newValues.answers) {
        const question = questions.filter(
          (item) => item.id === parseInt(answer.question)
        );
        const questionCorrectAnswers = question[0].options.filter(
          (item) => item.correct === true
        );
        if (question[0].type_id === 1 || question[0].type_id === 4) {
          if (
            questionCorrectAnswers.findIndex(
              (item) => item.id === parseInt(answer.options[0])
            ) >= 0
          ) {
            correctAnswers++;
          }
        } else if (question[0].type_id === 2 || question[0].type_id === 5) {
          const tempCorrectAnswer = [];
          for (let item of answer.options) {
            if (
              questionCorrectAnswers.findIndex(
                (i) => i.id === parseInt(item)
              ) >= 0
            ) {
              tempCorrectAnswer.push(item);
            }
          }
          if (
            tempCorrectAnswer.length === questionCorrectAnswers.length &&
            tempCorrectAnswer.length === answer.options.length
          ) {
            correctAnswers++;
          }
        }
      }

      const correct_answer_percentage = correctAnswers / questions.length;

      newValues.correct_answer_percentage = correct_answer_percentage;
      newValues.answer_percentage = correct_answer_percentage;
      newValues.type_id = props.activities.detail.type_id;
    }

    props.submitSurvey(newValues, props.history);
  }

  return (
    <>
      <div
        className="row justify-content-center mb-4"
        style={{ backgroundColor: COMPANY_SIGNED_IN_BACKGROUND_COLOR }}
      >
        <div className="col-auto text-center">
          <Typography variant="h5">
            {props.activities.detail?.name || 'Pesquisa'}
          </Typography>
        </div>
      </div>
      <div
        className="row justify-content-center"
        style={{ backgroundColor: COMPANY_SIGNED_IN_BACKGROUND_COLOR }}
      >
        <div className="col-12">
          <form onSubmit={props.handleSubmit(onSubmit)} noValidate>
            <div style={{ marginBottom: 10 }}>{questions[step]}</div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 10,
                backgroundColor: COMPANY_SIGNED_IN_BACKGROUND_COLOR,
              }}
            >
              <Typography variant="body1">
                {`${step + 1} de ${questions.length}`}
              </Typography>
            </div>
            <div
              className="row justify-content-center"
              style={{ padding: '0px 15px 30px' }}
            >
              {step > 0 && (
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      color: COMPANY_COLORS.primary,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      textAlign: 'center',
                    }}
                    onClick={() => setStep(s => s - 1)}
                  >
                    Anterior
                  </span>
                </div>
              )}
              {step < questions.length - 1 ? (
                <ButtonPrimary style={{ flex: 1, margin: 0 }} type="submit">
                  Próximo
                </ButtonPrimary>
              ) : (
                <ButtonPrimary
                  style={{ flex: 1, margin: 0 }}
                  type="submit"
                  disabled={props.activities.buttonLoading}
                  progress={parseInt(props.general.submitProgress, 10)}
                >
                  {props.activities.buttonLoading ? 'Enviando' : 'Enviar'}
                </ButtonPrimary>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

SurveysForm = reduxForm({ form: 'surveysForm' })(SurveysForm);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    formValues: getFormValues('surveysForm')(state),
    questions: state.activities.detail.researches[0].questions,
    activities: state.activities,
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { submitSurvey, setFeedbackModal, getLottieById, getUserPoints },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveysForm);
